import Input from "components/common/input";
import {
  careManagerInitialValues,
  careManagerSchema,
} from "constants/careManager";
import { ErrorMessage, Formik } from "formik";
import SelectComponent from "components/common/select";
import ToggleButton from "components/common/togglebutton";
import React, { useEffect, useState } from "react";
import AsyncSelect from "components/common/select/AsyncSelect";
import {
  getCounties,
  getStates,
  getHealthPlans,
} from "containers/policies/api";
import { initialMetaForTable } from "constants/common";
import {
  useDebouncedCountiesDataCallback,
  useDebouncedStatesDataCallback,
} from "utils/debouncedHelper";
import { formatLocation } from "utils/common";

const CareManagerForm = ({
  handleQuestionSubmittion,
  handleClose,
  currentLeadCareManagerEdit,
  // zipCodeList,
  // handleZipcodeSearch,
}) => {
  const [statesList, setStatesList] = useState([]);
  const [countiesList, setCountiesList] = useState([]);
  const [healthPlansList, setHealthPlansList] = useState([]);
  const debouncedStatesDataCallback = useDebouncedStatesDataCallback();
  // const debouncedCountiesDataCallback = useDebouncedCountiesDataCallback();
  const debouncedCoutiesDataCallback = useDebouncedCountiesDataCallback();
  const fetchStates = async () => {
    try {
      const result = await getStates({ ...initialMetaForTable });
      if (result?.states) {
        setStatesList(result.states);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCounties = async (stateId) => {
    const result = await getCounties({
      ...initialMetaForTable,
      state_id: stateId,
    });
    if (result["counties"]) {
      const data = result?.counties;
      setCountiesList(data);
    }
  };

  const fetchHealthPlan = async (searchString) => {
    const result = await getHealthPlans({
      ...initialMetaForTable,
      search: searchString,
    });

    if (result["health_plans"]) {
      const data = result?.health_plans;
      setHealthPlansList(data);
    }
  };

  useEffect(() => {
    fetchStates();
    fetchHealthPlan();
  }, []);

  useEffect(() => {
    if (
      Array.isArray(currentLeadCareManagerEdit?.states) &&
      currentLeadCareManagerEdit.states.length
    ) {
      const stateIds = currentLeadCareManagerEdit.states.map((s) =>
        typeof s === "object" ? s.value || s.id : s
      );
      fetchCounties(stateIds);
    }
  }, [currentLeadCareManagerEdit]);

  return (
    <Formik
      initialValues={
        typeof currentLeadCareManagerEdit === "object"
          ? currentLeadCareManagerEdit
          : careManagerInitialValues
      }
      validationSchema={careManagerSchema}
      onSubmit={(values, { setErrors }) => {
        handleQuestionSubmittion(values, setErrors);
      }}
    >
      {({ handleChange, values, handleSubmit, errors, setFieldValue }) => {
        console.log("errors", errors);
        return (
          <div className="question-modal">
            <form className="form-main" onSubmit={handleSubmit}>
              <hr className="custom-modal-line mt-0" />
              <div className="col-sm-6 mt-2 pt-1">
                <ToggleButton
                  label="Status"
                  handleChange={(name, value) => {
                    setFieldValue(name, value ? "active" : "inactive");
                  }}
                  value={values.status === "active" ? 1 : 0}
                  name="status"
                />
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. Michael Johnson"
                    type="text"
                    label="Care Manager Name"
                    value={values.name}
                    name="name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="name"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. johndoe@gmail.com"
                    type="email"
                    label="Email"
                    value={values.email}
                    disabled={
                      typeof currentLeadCareManagerEdit === "object" &&
                      Object.keys(currentLeadCareManagerEdit).length
                    }
                    name="email"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="email"
                      />
                    }
                  />
                </div>
              </div>

              <div className="input-flex row">
                <div className="col-sm-12">
                  <Input
                    handleChange={handleChange}
                    placeholder="Enter Capacity"
                    type="number"
                    label="Capacity"
                    value={values.capacity}
                    name="capacity"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="capacity"
                      />
                    }
                  />
                </div>

                <div>
                  <AsyncSelect
                    label="Health Plan"
                    isMulti={true}
                    options={healthPlansList?.map((el) => ({
                      value: el.id,
                      label: el.name,
                    }))}
                    dataCallback={async (inputValue) => {
                      try {
                        const response = await getHealthPlans({
                          search: inputValue,
                        });
                        return (
                          response?.health_plans?.map((el) => ({
                            value: el.id,
                            label: el.name,
                          })) || []
                        );
                      } catch (error) {
                        console.error("Error fetching health plans:", error);
                        return [];
                      }
                    }}
                    selectedValue={values.health_plans}
                    placeholder="Select Health Plan"
                    handleChange={(arr) => {
                      setFieldValue("health_plans", arr);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="health_plan_id"
                      />
                    }
                  />
                </div>

                <div>
                  <AsyncSelect
                    label="State"
                    isMulti={true}
                    options={
                      statesList.find(
                        (plan) =>
                          plan.id === currentLeadCareManagerEdit?.state_id
                      ) ||
                      typeof currentLeadCareManagerEdit?.state_id == "undefined"
                        ? [
                            ...statesList?.map((el) => {
                              return {
                                value: el.id,
                                label: el.name.toUpperCase(),
                              };
                            }),
                          ]
                        : [
                            ...statesList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: currentLeadCareManagerEdit.state?.id,
                              label: currentLeadCareManagerEdit.state?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedStatesDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.states}
                    placeholder="Select State"
                    handleChange={(arr) => {
                      setFieldValue("states", arr);
                      const stateIds = arr.map((state) => state.value);
                      setFieldValue("counties", []);
                      fetchCounties(stateIds);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="state_id"
                      />
                    }
                  />
                </div>

                <div>
                  <AsyncSelect
                    label="County"
                    isMulti={true}
                    options={
                      countiesList.find(
                        (plan) =>
                          plan.id === currentLeadCareManagerEdit.county_id
                      ) ||
                      typeof currentLeadCareManagerEdit.county_id == "undefined"
                        ? [
                            ...countiesList?.map((el) => {
                              return {
                                value: el.id,
                                label: formatLocation(el.name),
                              };
                            }),
                          ]
                        : [
                            ...countiesList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: currentLeadCareManagerEdit.county?.id,
                              label: currentLeadCareManagerEdit.county?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCoutiesDataCallback(
                          inputValue,
                          values.states?.map((s) => s.value),
                          resolve
                        );
                      })
                    }
                    selectedValue={values.counties}
                    placeholder="Select County"
                    handleChange={(arr) => {
                      setFieldValue("counties", arr);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="county_id"
                      />
                    }
                    isDisabled={!values.states?.length}
                  />
                </div>
              </div>

              <hr className="custom-modal-line mt-4" />

              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <input
                  className="primary-btn w-50 fs-6 small"
                  type="submit"
                  name="submit"
                  value={
                    typeof currentLeadCareManagerEdit === "object" &&
                    Object.keys(currentLeadCareManagerEdit).length
                      ? "Save Changes"
                      : "Add Care Manager"
                  }
                />
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default CareManagerForm;
